import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "translations",
  "use": "translations-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"translations\"><path d=\"M10 18.334a8.333 8.333 0 100-16.667 8.333 8.333 0 000 16.667zM1.667 10h16.666\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M10 1.667A12.75 12.75 0 0113.333 10 12.75 12.75 0 0110 18.334 12.75 12.75 0 016.667 10 12.75 12.75 0 0110 1.667v0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/translations.svg
// module id = LLA2
// module chunks = 39 44